import type { PopupData } from 'webapp-types';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import MetricPushComponent from 'webapp/components/metric/push/index';
import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';

export default class MetricPushPopupComponent extends PopupInnerModalComponent<PopupData.Metric.Push> {
	get model() {
		return this.popupData.model;
	}
	<template>
		<div class="title">
			<CommonUiIconComponent @name="Upload" @size="sm" />Store value to '{{this.model.name}}'
		</div>

		<div class="content">

			<MetricPushComponent @model={{this.model}} @onClose={{this.close}} />

		</div>
	</template>
}
